import instance, { ADMIN_PREFIX } from 'services/api';
import { ConfigBody, ConfigRow } from 'types/api/config';

/**
 * GET /api/v2/admin/config/:type — org-scoped via the `organization`
 * header (set globally by the axios interceptor: subOrg || parentOrg).
 * BE returns a synthetic 200 with the registry defaultBody when no row
 * exists yet (cycle-39 closure), so the editor mounts empty on first
 * open and the first Save creates the persistent row.
 */
export const fetchConfigByType = async (
  type: string
): Promise<ConfigRow | null> => {
  const res = await instance.get<ConfigRow>(`${ADMIN_PREFIX}/config/${type}`);

  return res.data ?? null;
};

/**
 * PUT /api/v2/admin/config/:type — upserts the row. `body` is the
 * raw jsonb object (do NOT JSON.stringify it; the BE DTO is @IsObject).
 * Org scope is taken from the `organization` header.
 */
export const upsertConfig = (type: string, body: ConfigBody) =>
  instance.put<ConfigRow>(`${ADMIN_PREFIX}/config/${type}`, { body });
